import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const SELECTOR = {
  ELEMENTS: [...document.querySelectorAll('[data-animate]')],
}

export default class ScrollAnimation {
  constructor() {
    if(!SELECTOR.ELEMENTS) return;

    gsap.registerPlugin(ScrollTrigger)

    SELECTOR.ELEMENTS.forEach(element => {
      switch (element.dataset.animate) {
        case 'fadeIn':
          this.fadeIn(element);
          break;
        case 'fadeInUp':
          this.fadeInUp(element);
          break;
        case 'fadeInUp-delay':
          this.fadeInUp(element, 1);
          break;
        case 'splitText':
          this.splitText(element);
          break;
        case 'bgText':
          this.bgText(element);
          break;
        case 'line':
          this.line(element);
          break;
        case 'benefits':
          this.benefits(element);
          break;
        case 'instagramBtn':
          this.instagramBtn(element);
          break;
      }
    });
  }

  fadeIn(element) {
    gsap.fromTo(
      element,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1.5,
        scrollTrigger: {
          trigger: element,
          start: element.dataset.triggerStart ? element.dataset.triggerStart : 'top 80%',
          ease: 'power2.out',
          markers: false,
        }
      }
    );
  }

  fadeInUp(element, delay = 0) {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        yPercent: 10,
      },
      {
        opacity: 1,
        yPercent: 0,
        duration: 1,
        delay,
        scrollTrigger: {
          trigger: element,
          start: element.dataset.triggerStart ? element.dataset.triggerStart : 'top 80%',
          ease: 'power2',
        }
      }
    );
  }

  splitText(element) {
    const str = element.innerHTML
    let text = ''

    str.split(/(?=[^>]*(?:<|$))/).forEach(char => {
      if (char.match(/[&<>'"]/)) {
        text += `${ char }`
        element.innerHTML = text
      } else {
        text += `<span>${ char }</span>`
        element.innerHTML = text
      }
      element.spans = [...element.querySelectorAll('span')];
    });

    gsap.fromTo(
      element.spans,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 2,
        ease: "power2.out",
        stagger: {
          each: 0.1
        },
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
        }
      }
    );
  }

  bgText(element) {
    element.bgs = [...element.querySelectorAll('[data-lead-bg]')];
    element.texts = [...element.querySelectorAll('[data-lead-text]')];

    gsap.fromTo(
      element.bgs,
      {
        xPercent: -100,
      },
      {
        xPercent: 0,
        duration: 0.5,
        stagger: {
          each: 0.5
        },
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
          ease: 'power2.out',
        }
      }
    );

    gsap.fromTo(
      element.texts,
      {
        opacity: 0,
        x: -5,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        delay: 0.6,
        stagger: {
          each: 0.5
        },
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
        }
      }
    );
  }

  benefits(element) {
    element.line = [...element.querySelectorAll('[data-benefit-line]')];
    element.label = [...element.querySelectorAll('[data-benefit-label]')];
    element.shadows = [...element.querySelectorAll('[data-benefit-shadow]')];

    gsap.fromTo(
      element.line,
      {
        strokeDasharray: '0 533',
        transform: 'rotate(-90deg)',
      },
      {
        strokeDasharray: '533 533',
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
        }
      }
    );

    gsap.fromTo(
      element.label,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        delay: 0.8,
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          ease: 'power2.out',
        }
      }
    );

    gsap.fromTo(
      element.shadows,
      {
        opacity: 0,
        yPercent: 10,
      },
      {
        opacity: 1,
        yPercent: 0,
        duration: 1,
        delay: 1.25,
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
          ease: 'power2.out',
        }
      }
    );
  }

  instagramBtn(element) {
    element.line = element.querySelector('[data-instagram-line]');
    gsap.fromTo(
      element.line,
      {
        strokeDasharray: '0 1200',
      },
      {
        strokeDasharray: '1200 1200',
        duration: 3,
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
          ease: 'power2',
        }
      }
    );
  }

  line(element) {
    gsap.fromTo(
      element,
      {
        strokeDashoffset: element.dataset.strokeDashoffset ? element.dataset.strokeDashoffset : '100%',
      },
      {
        strokeDashoffset: 0,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: element,
          start: element.dataset.triggerStart ? element.dataset.triggerStart : 'top top',
          end: element.dataset.triggerEnd ? element.dataset.triggerEnd : 'bottom center',
          scrub: true,
          markers: false,
        }
      }
    );
  }

}